import {filter, uniq, isEmpty} from 'lodash';
import pageRoute from '@/libs/constant/pageRoutes';
import { getImageUrl, onError, getDate } from '@/libs/helper';
import SettingsDropdown from '@/components/component/Reuse/SettingsDropdown/SettingsDropdown.vue';
import BulkUpdate from '@/components/pages/InformationPortal/ShortURLService/BulkUpload/BulkUpdate.vue';
import { mapGetters }  from 'vuex';
import permissions from '@/libs/constant/permissions'

export default {
    name: 'ShortURL',
    components: {
        SettingsDropdown,
        BulkUpdate 
    },
    computed: {
        perPageSelect: {
            get(){
                return this.pageSize
            },
            set(val){
                this.pageSize = val
                this.skip=0
                this.currentPage = 1
                this.$emit('params', this.params)
                this.refreshPage()
            },
        },
        ...mapGetters(['hasPermission']),
        isArchive () {
            if (this.$route.name === pageRoute.shortURLArchiveURLS) return true
            else false
        },
        params() {
            return `?skip=${this.skip}&limit=${this.pageSize}`
        },
    },
    watch: {
        activeTableColumns: function (newArray) {
            this.filterOption = Object.assign([], newArray)
        }
    },
    props: {
        activeUrls: {
            type: Array,
            default: () => []
        },
        archivedUrls: {
            type: Array,
            default: () => []
        },
        getLocationImageUrl: {
            type: Function,
            default: () => {}
        },
        handleLocationRedirection: {
            type: Function,
            default: () => {}
        },
        getLocationRouteName: {
            type: Function,
            default: () => {}
        },
        reportingGroups: {
            type: Array,
            default: () => []
        },
        totalCount: {
            type: Number,
            default: 0
        }
    },
    created () {
        this.baseUrl = process.env.VUE_APP_ENV === 'production' ? 'accura.onl' : process.env.VUE_APP_ENV === 'staging' ? 'web-staging.accura.onl' : 'web-dev.accura.onl'
    },
    mounted() {
        this.routeType = this.isArchive ? 'archiveTableColumns' : 'activeTableColumns'
        if (JSON.parse(localStorage.getItem('activeTableColumns')) && this.routeType == 'activeTableColumns') {
            this.activeTableColumns = JSON.parse(localStorage.getItem('activeTableColumns'))
        } else if (JSON.parse(localStorage.getItem('archiveTableColumns')) && this.routeType == 'archiveTableColumns') {
            this.activeTableColumns = JSON.parse(localStorage.getItem('archiveTableColumns'))
        }
        this.$emit('params', this.params)
    },
    data() {
        return {
            getImageUrl, 
            onError,
            getDate,
            activeTableColumns: [
                'location',
                'short_url',
                'clicks',
                'created_by',
                'date_created',
                'settings'
            ],
            tableSettings: {
                headings: {
                    location: 'Location',
                    short_url: 'Short URL',
                    settings: '',
                    clicks: 'Clicks',
                    created_by: 'Created By',
                    date_created: 'Date Created'
                },
                pagination: { show: true},
                perPage: 25,
                filterable: [],
                filterByColumn: true,
                sortable: ['no']
            },
            currentPage: 1,
            skip: 0,
            pageSize: '10',
            limit: 30,
            sort: 'name',
            order: 'desc',
            tableColumnsSetting: [
                {key: 'location', name: 'Location'},
                {key: 'short_url', name: 'Short URL'},
                {key: 'clicks', name: 'Clicks'},
                {key: 'created_by', name: 'Created By'},
                {key: 'date_created', name: 'Date Created'},
                {key: 'settings', name: 'Settings'}
            ],
            filterOption: [],
            markedRows: [],
            isAllMarked: false,
            allMarked: false,
            showBulkUpdate: true,
            isBulkEdit: false,
            routeType: '',
            isEmpty,
            isReportingGroups: false,
            markedReporting: [],
            selectedRowItem: {},
            selected: 10,
            permissions: permissions
        }
    },
    methods: {
        /**
         * route to dashboard
         */
        routeToURLDashboard () {
            this.$router.push({name: pageRoute.shortURLDashboard})
        },
        /**
         * route to member page
         */
        routeToMemberPage (user) {
            if (user && (user._id || user.id)) {
                this.$router.push({name: pageRoute.usersOverview, params: {id: user._id || user.id}})
            }
        },
        /**
         *to change order
         */
         changeOrder () {
            // change sort
            this.order = this.order === 'desc' ? 'asc' : 'desc'
            // set skip to zero
            this.skip = 0
        },

        /**
         * handle command 
         */
        handleCommand (command, data) {
            switch (command) {
                case 'DASHBOARD':
                    this.$router.push({name: pageRoute.shortURLDashboard, params: {id: data._id}})
                break
                case 'SETTINGS':
                    this.$router.push({name: pageRoute.shortURLInternalSettings, params: {id: data._id}})
                break
                case 'ARCHIVE':
                    this.$emit('convertToArchive', data)
                break;
                case 'ACTIVE':
                    this.$emit('convertToActive', data)
                break;
                case 'ADD_TO_URL_REPORTING_GROUP':
                    this.selectedRowItem = data
                    this.isReportingGroups = true
                break;
            }
        },
        addOrRemoveColumn (isChecked, val) {
            this.filterOption = JSON.parse(localStorage.getItem(this.routeType)) || this.activeTableColumns
            if (isChecked) {
                this.filterOption.push(val.key)
            } else {
                this.filterOption = this.filterOption.filter(item => item !== val.key)
            }
            this.activeTableColumns = filter(this.tableColumnsSetting, (o) => uniq(this.filterOption).includes(o.key)).map((o) => o.key)
            localStorage.setItem(this.routeType, JSON.stringify(this.activeTableColumns))
        },
        toggleAll (event) {
            if (!this.showBulkUpdate) return
            this.markedRows = []
            this.allMarked = event
            this.markedRows = this.allMarked?this.$refs.table.data.map(row=>row._id):[]       
            if(!isEmpty(this.markedRows)) {
                this.markedRows = this.markedRows.filter((item,index)=>{
                    if(index < this.selected)
                        return item
                })
            }
        },
        bulkEdit () {
            this.isBulkEdit = true
        },
        clearBulkSelection () {
            this.markedRows = []
            this.isAllMarked = false
            this.isBulkEdit = false
        },
        toggleSingleItem(id) {
            if (!this.markedRows.includes(id)) {
              this.markedRows.push(id)
           } else {
               const index = this.markedRows.indexOf(id)
               if (index > -1) {
               this.markedRows.splice(index, 1);
               }
           }
        },
        toggleReportingGroups(id) {
            if (!this.markedReporting.includes(id)) {
                this.markedReporting.push(id)
            } else {
                const index = this.markedReporting.indexOf(id)
                if (index > -1) {
                    this.markedReporting.splice(index, 1);
                }
            }
        },
        updateReporting () {
            let data = {
                markedReporting: this.markedReporting,
                rowItem: this.selectedRowItem
            }
            this.$emit('update-reporting', data); 
            this.isReportingGroups = false;
            this.markedReporting= []
            this.selectedRowItem = {}
        },
        refreshPage () {
            this.markedRows = []
            this.$emit('refreshPage')
        },
        changePage (currentPage) {
            this.previousPage = this.currentPage
            this.currentPage = currentPage
            // this.skip = (currentPage - 1) * this.selectedValue
            this.skip = (currentPage - 1) * this.pageSize
            this.$emit('params', this.params)
            this.refreshPage()
        },
    }
}